import styled from 'styled-components';
import { CheckMark } from './shared.tsx';

const checkMarkBoxSize = '14px';

// see also CheckMark (without the box)
export function CheckBox({
  onClick,
  isChecked,
  children,
}: {
  onClick: () => void;
  isChecked: boolean;
  children?: React.ReactNode;
}) {
  return (
    <CheckMarkBoxWrapper onClick={onClick}>
      {children}
      <CheckMarkBoxOutline
        $size={`calc(${checkMarkBoxSize} + 4px)`}
        $fillColor={isChecked ? 'var(--color-planner-checkmark-background)' : undefined}
      />
      {isChecked && (
        <CheckMarkWrapper
          $size={checkMarkBoxSize}
          $fillColor={'var(--color-background)'}
          $noAutoMargin={true}
          $padding={'0'}
        />
      )}
    </CheckMarkBoxWrapper>
  );
}

const CheckMarkBoxWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: ${checkMarkBoxSize};
  height: ${checkMarkBoxSize};
  cursor: pointer;
`;

const CheckMarkBoxOutline = styled.div<{ $size: string; $fillColor?: string }>`
  position: absolute;
  border-radius: 3px;
  ${(props) => (props.$fillColor ? '' : 'border: 2px solid var(--color-input-border)')};
  background-color: ${(props) => props.$fillColor};
  top: 0;
  bottom: 0;
  margin: auto;
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
`;

const CheckMarkWrapper = styled(CheckMark)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateX(2px);
`;
